import CustomButton from '@/components/atoms/CustomButton';
import colors from '@/theme/colors';
import { ButtonProps, HStack } from '@chakra-ui/react';
import React from 'react';

export interface ConfirmCancelButtonProps {
  onCancel: () => void;
  onConfirm?: () => void;
  confirmButtonText: string;
  confirmButtonType?: ButtonProps['type'];
  confirmButtonColor?: string;
  minButtonWidth?: string;
  confirmButtonDisabled?: boolean;
  confirmLoading?: boolean;
  marginBottom?: string;
}

const ConfirmCancelButtons = ({
  onCancel,
  onConfirm,
  confirmButtonText,
  confirmButtonType,
  confirmButtonColor,
  minButtonWidth = '110px',
  confirmButtonDisabled,
  confirmLoading,
  marginBottom = '20px',
}: ConfirmCancelButtonProps) => {
  return (
    <HStack justifyContent={'center'} width={'100%'} marginBottom={marginBottom} gap={'30px'}>
      <CustomButton
        isTransparent
        labelColor="text.mediumBlue"
        labelHoverColor={colors.extra.black}
        borderHoverColor="transparent"
        label="Cancel"
        onClick={onCancel}
        labelStyle={{ fontSize: '16px' }}
        style={{ marginTop: '20px' }}
        height={'60px'}
        width={minButtonWidth}
      />

      <CustomButton
        label={confirmButtonText}
        labelColor="extra.white"
        labelHoverColor="extra.white"
        backgroundColor={confirmButtonColor}
        labelStyle={{ fontSize: '16px' }}
        onClick={onConfirm}
        style={{ marginTop: '20px', minWidth: minButtonWidth }}
        height={'60px'}
        isLoading={confirmLoading}
        disabled={confirmButtonDisabled}
        buttonType={confirmButtonType}
      />
    </HStack>
  );
};

export default ConfirmCancelButtons;
